var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBeenHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5188 18.2714C18.1381 16.3844 20.0656 13.4489 20.0498 10.1774C20.0498 5.88962 16.5623 2.40137 12.2753 2.40137C7.98834 2.40137 4.50009 5.88662 4.50009 10.1714C4.48509 13.4466 6.41184 16.3836 8.03109 18.2706C9.87384 20.4186 11.7466 21.7514 11.8253 21.8069C12.0901 21.9959 12.4613 21.9959 12.7253 21.8069C12.8041 21.7506 14.6836 20.4104 16.5188 18.2714ZM12.4171 20.0864L12.2753 20.2019L12.1336 20.0864C11.3371 19.4399 9.80484 18.0959 8.48409 16.3551C6.85959 14.2146 6.04134 12.1356 6.05034 10.1759C6.05034 6.74387 8.84259 3.95162 12.2753 3.95162C15.7066 3.95162 18.4996 6.74612 18.5011 10.1811C18.5101 12.1394 17.6911 14.2169 16.0666 16.3566C14.7458 18.0981 13.2136 19.4406 12.4171 20.0864Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34575 9.65162L8.25 10.7474L11.6392 14.1366L17.028 8.74712L15.9322 7.65137L11.6392 11.9444L9.34575 9.65162Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBeenHere);
export default __webpack_public_path__ + "static/media/icons-been-here.5af7d862b18ee4453c99732fbdfd2007.svg";
export { ForwardRef as ReactComponent };